import convertCurrencyFormat from './currencyFormatter';

const formatPromoMessage = (promo) => {
  const priceInDollar = convertCurrencyFormat(promo.discount_amount / 100, 'USD', 0, 0);
  if (promo.minimum_spend > 0) {
    const minPriceInDollar = convertCurrencyFormat(promo.minimum_spend / 100, 'USD', 0, 0);
    return promo.discount_type === 'PERCENT_OFF'
      ? `${promo.discount_amount}% Off ${minPriceInDollar}+ With Code`
      : `${priceInDollar} Off ${minPriceInDollar}+ With Code`;
  }

  return promo.discount_type === 'PERCENT_OFF'
    ? `${promo.discount_amount}% Off With Code`
    : `${priceInDollar} Off With Code`;
};

export default formatPromoMessage;
